import { safeDefine } from "../../registration/safe-define.js";
import { SeekIndicatorValueElement } from "../../ui/seek-indicator/value.js";
//#region src/define/ui/seek-indicator-value.ts
safeDefine(SeekIndicatorValueElement);
//#endregion

//# sourceMappingURL=seek-indicator-value.js.map